// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23ffffff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M2 5l6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --white: #ffffff;
  --black: #000000;
  --primary: #12151D;
  --primary-95: #242837;
  --TabBgActive: #12151D;
  --golden: #FFC700;
  --borderBg: #242837;
  --HistoryText: #ECA72C;
  --incrementBg: #060714;
  --buttonBg: #EF7403;
  --footerTopBorder: rgba(239, 239, 239, 0.25);
  --multiple: #222224;
  --TabColor: rgba(239, 239, 239, 0.50);
  --textColor: #EFEFEF;
  --autopickBg: #0A0A0D;
  --success: #4DA500;
  --danger: #F23546;
  --Active: #52BA53;
  --Loss: #D32B46;
  --bodyBg: #000000;
  --white-100: #efefef;
  --borderColor: #5A84FF;
  --checkBoxBorder: #47506F;
  --toggleButton: #0D0710;
  --WagerInput: #181B25;
  --StateBg: #031430;
  --historyLoss: #0A3477;
  --inputAddon: #0270F0;
  --riskLevel: #434C57;
  --NumberBg: #353A47;
  --TapTapBetBg: #0D1833;
  --TapTapBetBtnBg: #FDFE8A;
  --TapTapStartGame: #FF8F3B;
  --dice-primary-main: linear-gradient(180deg, #FFA800 0%, #A86F00 100%);
  --dice-primary-800: #6238BB;
  --dice-primary-main-2: rgba(137, 83, 252, 0.2);
  --dice-green-main: #2CB575;
  --Game-Base-Green: #0D6F51;
  --dice-dark-700-75: rgba(10, 12, 18, 0.75);
  --dice-grey-100: #D9D9D9;
  --dice-grey-200: #B4B6C1;
  --dice-grey-300: #9598A7;
  --dice-grey-400: #686C81;
  --dice-grey-600: #49617C;
  --diceSliderBg: #13151A;
  --zinc-600: #52525B;
  --zinc-650: #4C4C52;
  --zinc-700: #252933;
  --zinc-800: #27272A;
  --zinc-850: #333333;
  --zinc-900: #18181B;
  --zinc-950: #09090B;
  --zinc-950-06: rgba(9, 9, 11, 0.6);
  --zinc-950-07: rgba(9, 9, 11, 0.7);
  --black: #000000;
  --black-20: rgba(0, 0, 0, 0.2);
  --black-30: rgb(0 0 0 / 30%);
  --gray-100-21: rgba(79, 79, 79, 0.21);
  --gray-200: #696969;
  --gray-300: #B8B8B8;
  --gray-400: #949494;
  --gray-700: #3D3D43;
  --gray-750: #272727;
  --gray-800: #212328;
  --gray-850-32: rgba(35, 35, 35, 0.32);
  --gray-850: #2A2A31;
  --gray-900: #191A1E;
  --gray-950: #232323;
  --gray-900-15: rgb(126 126 126 / 21%);
  --gray-975: #040404;
  --yellow-200-02: rgba(255, 230, 0, 0.2);
  --yellow-200-04: rgba(255, 230, 0, 0.4);
  --yellow-200-20: rgba(255, 229, 0, 0.20);
  --yellow-200-24: rgba(255, 230, 0, 0.24);
  --yellow-200-30: rgba(255, 229, 0, 0.30);
  --yellow-200-54: rgba(255, 230, 0, 0.54);
  --yellow-200-94: rgba(255, 230, 0, 0.94);
  --yellow-300-60: rgba(255, 230, 117, 0.60);
  --yellow-200-61: rgba(255, 222, 82, 0.61);
  --yellow-400: #F6D76B;
  --yellow-500: #F6C36B;
  --yellow-600: #FFE353;
  --yellow-700: #213621;
  --yellow-800: #EBC500;
  --yellow-900: #443D00;
  --pink-300: #FE6969;
  --pink-400: #E7635E;
  --pink-600: #E34A5C;
  --orange-300: #F0A265;
  --orange-350: #F39946;
  --orange-400: #F4754D;
  --orange-500: #FF5C00;
  --orange-900: rgba(244, 117, 77, 0.30);
  --orange-950-40: rgba(255, 229, 0, 0.40);
  --red-500: #EF4444;
  --red-600: #F80027;
  --red-900: #200000;
  --cyan-400: #7EFFF0;
  --cyan-900: #02312C;
  --purple-100-08: rgba(179, 19, 255, 0.08);
  --purple-100-30: rgba(179, 19, 255, 0.30);
  --purple-200: #0689FF;
  --purple-400: #8000FF;
  --purple-500: #B313FF;
  --purple-600-04: rgba(98, 1, 255, 0.4);
  --purple-600-24: rgba(98, 1, 255, 0.24);
  --purple-600-54: rgba(98, 1, 255, 0.54);
  --purple-600-94: rgba(98, 1, 255, 0.94);
  --purple-600-66: rgba(129, 59, 242, 0.66);
  --green-400: #6CF96C;
  --gameContainerBg: linear-gradient(180deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.02) 100%);
  --purpleYellowRadialGradient: radial-gradient(76.67% 76.67% at 50% 50%, #FFE600 0%, #B947FF 100%);
  --purpleYellowRadialGradientHover: radial-gradient(68.33% 68.33% at 50% 50%, #FFE600 44.27%, #B947FF 100%);
  --purpleYellowRadialGradientActive: linear-gradient(0deg, rgba(255, 229, 0, 0.3), rgba(255, 229, 0, 0.3)),
    radial-gradient(68.33% 68.33% at 50% 50%, #FFE600 22.92%, #B947FF 100%);
  --orangeYellowRadialGradient: radial-gradient(61.67% 61.67% at 50% 50%, #FFE500 0%, #FF7A01 100%);
  --orangeYellowRadialGradientShadow: 0px 1px 12.2px 3px rgba(255, 229, 0, 0.40);
  --orangeYellowRadialGradientHover: radial-gradient(61.67% 61.67% at 50% 50%, #FFFF46 0%, #F58E15 100%);
  --orangeYellowRadialGradientHoverShadow: 0px 4px 0px 0px #AA5100, 0px 1px 12.2px 3px rgba(255, 229, 0, 0.40);
  --orangeYellowRadialGradientDisable: linear-gradient(0deg, rgba(170, 81, 0, 0.30) 0%, rgba(170, 81, 0, 0.30) 100%), radial-gradient(61.67% 61.67% at 50% 50%, #FFFF46 0%, #F58E15 100%);
  --orangeYellowRadialGradientDisableShadow: 0px 4px 0px 0px #AA5100, 0px 1px 12.2px 3px rgba(255, 229, 0, 0.40);
  --orangeYellowRadialGradientActive: linear-gradient(0deg, rgba(255, 229, 0, 0.30) 0%, rgba(255, 229, 0, 0.30) 100%),
    radial-gradient(68.33% 68.33% at 50% 50%, #FFE500 22.92%, #FF7A01 100%);
  --plinkoBgGradient: linear-gradient(0deg, rgba(255, 77, 38, 0.40) 0%, rgba(255, 135, 24, 0.25) 7.29%, rgba(255, 229, 0, 0.00) 70.31%, rgba(255, 255, 255, 0.00) 94.27%);
  --plinkoSidebarGradient: linear-gradient(0deg, rgba(7, 77, 198, 0.40) 0%, rgba(125, 33, 131, 0.40) 8.85%, rgba(35, 35, 35, 0.32) 94.27%);
  --primaryBtnShadow: 0px 9px 7.099999904632568px 0px #FFFFFF7A inset, 0px -2px 10px 0px #D08732 inset;
  --input-ps: 0.75rem;
  --input-pe: 0.75rem;
  --mineplacebet: #252933;
  --diamondBackground: #4F0473;
  --diamondBlockText: #FFE500;
  --PlinkoSidebarBg: #13151A;
  --plinkoBtnPrimary: #252933;
  --borderPinkColor: #BE3EFA;
  --plinkoSwitchThumbnail: #5E29BB;
  --plinkoSwitchBg: #17062C;
  --plinkoInputBg: #220B3E;
  --plinkoBtnGreen01: #45E90C;
  --plinkoBtnGreen02: #02472E;
  --plinkoSelectBorder: #4B2280;
  --plinkoTableBg: #271142;
  --plinkoHeaderBtnBg: #220B47;
  --plinkoMusicMuted: #4D2198;
  --plinkoSettingBtnBorder: #7340FF;
  --plinkoHrLine: #3F1670;
  --plinkoOrange800: #FC6F1F;
  --plinkoBlue700: #346DFF;
  --plinkoBlue300: #3CBCB4;
  --plinkoPurple500: #B122F4;
  --plinkoRed800: #C82020;
  --plinkoShadowGreen: #67FF4F;
  --plinkoBtnPrimaryHover: linear-gradient(180deg, #BE3EFA 0%, #6217AC 82.61%);
  --primaryGradient: linear-gradient(114.49deg, #8700C7 31.29%, #E06447 81.89%, #FFBF19 99.86%);
  --primaryHoverGradient: linear-gradient(0deg, #8700C7 31.29%, #E06447 81.89%, #FFBF19 99.86%);
  --sliderOverlayGradient: linear-gradient(270deg, #0A3477 0%, rgba(30, 10, 42, 0) 100%);
  --sliderOverlayGradient180deg: linear-gradient(180deg, rgba(40, 17, 55, 0) 0%, #1A0825 100%);
  --onyx-700: #353B40;
  --greenGradient: conic-gradient(from 180deg at 50% 50%, #1a9a8f 0deg, #0d6f51 360deg);
  --white-o10: #8DE1A5;
  --lightBlue: #4768E8;
  --lightPurple: #9633FA;
  --lightOrange: #E58808;
}

.form-control:focus {
  box-shadow: none;
  border-color: var(--primary-95) !important;
  color: var(--textColor) !important;
}

html,
body {
  height: 100%;
  overflow-x: hidden;
  background-color: var(--bodyBg);
}
html .spinner-border,
body .spinner-border {
  width: 1rem;
  height: 1rem;
}

*::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: var(--zinc-700);
  border-radius: 50em;
}
*::-webkit-scrollbar {
  width: 2px;
  background-color: var(--zinc-700);
  border-radius: 50em;
  height: 5px;
}
*::-webkit-scrollbar-thumb {
  border-radius: 50em;
  background-color: var(--gray-400);
}

body {
  color: var(--white);
  font-size: 0.938rem;
  font-family: "Lexend", serif;
  font-optical-sizing: auto;
  font-style: normal;
  font-weight: 500;
}
body #root {
  height: 100%;
}
body .container-fluid {
  max-width: 100%;
  border-radius: 0;
  background: var(--primary);
  padding: 0;
  height: 100vh;
}
@media screen and (max-width: 991.98px) {
  body .container-fluid {
    height: auto;
  }
}
body .container-fluid .parent {
  gap: 12px;
}
@media screen and (max-width: 991px) {
  body .container-fluid .parent {
    flex-direction: column-reverse;
  }
}
@media screen and (max-width: 767.99px) {
  body .container-fluid.multi-crash {
    height: auto;
  }
}
body .container-fluid.multi-crash .row {
  height: calc(100% - 57px);
}
body .nav-tabs {
  background-color: var(--primary-95);
  border-radius: 8px;
  padding: 0.5px 2.5px;
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  padding-bottom: 2px;
}
body .nav-tabs .nav-item .nav-link {
  color: var(--TabColor);
  border-radius: 8px;
  padding: 0;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  text-transform: capitalize;
  padding: 4px 0;
  height: 40px;
}
body .nav-tabs .nav-item .nav-link.active {
  background-color: var(--TabBgActive);
  color: var(--white);
  height: 100%;
}
body .btn-nav-tabs .btn-nav-tab-items:nth-child(1) .btn-tab {
  color: var(--yellow-700);
}
body .btn-nav-tabs .btn-nav-tab-items:nth-child(1) .btn-tab:is(:hover):enabled:not(.active), body .btn-nav-tabs .btn-nav-tab-items:nth-child(1) .btn-tab.active {
  background-color: var(--yellow-400);
  border-color: var(--yellow-400);
  color: var(--black);
}
body .btn-nav-tabs .btn-nav-tab-items:nth-child(2) .btn-tab {
  color: var(--orange-400);
}
body .btn-nav-tabs .btn-nav-tab-items:nth-child(2) .btn-tab:is(:hover):enabled:not(.active), body .btn-nav-tabs .btn-nav-tab-items:nth-child(2) .btn-tab.active {
  background-color: var(--orange-400);
  border-color: var(--orange-400);
  color: var(--zinc-950);
}
body .btn-nav-tabs .btn-nav-tab-items:nth-child(3) .btn-tab {
  color: var(--red-500);
}
body .btn-nav-tabs .btn-nav-tab-items:nth-child(3) .btn-tab:is(:hover):enabled:not(.active), body .btn-nav-tabs .btn-nav-tab-items:nth-child(3) .btn-tab.active {
  background-color: var(--red-500);
  border-color: var(--red-500);
  color: var(--zinc-950);
}
body .btn-nav-tabs .btn-nav-tab-items:nth-child(4) .btn-tab {
  color: var(--cyan-400);
}
body .btn-nav-tabs .btn-nav-tab-items:nth-child(4) .btn-tab:is(:hover):enabled:not(.active), body .btn-nav-tabs .btn-nav-tab-items:nth-child(4) .btn-tab.active {
  background-color: var(--cyan-400);
  border-color: var(--cyan-400);
  color: var(--zinc-950);
}
body .btn-nav-tabs .btn-tab {
  background-color: var(--zinc-800);
  border-color: var(--zinc-800);
  color: var(--white);
  padding: 0.25rem 0.25rem;
  font-weight: 500;
  min-width: 48px;
  height: 36px;
  border-radius: 0.25rem;
}
body .btn-nav-tabs .strategy-btn-box .btn-outline-warning:hover,
body .btn-nav-tabs .strategy-btn-box .btn-outline-orange:hover,
body .btn-nav-tabs .strategy-btn-box .btn-outline-danger:hover {
  background-color: var(--zinc-800);
  border-color: var(--zinc-700);
  color: var(--white);
}
body select.form-control {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat right var(--primary-95);
  -webkit-appearance: none;
  background-position: calc(100% - 12px);
  background-size: 16px;
  padding-right: 35px !important;
  border-color: var(--buttonBg);
  color: #fff;
}
body .custom-input-group .custom-input-group-text {
  gap: 0.375rem;
}
body .custom-input-group .custom-input-group-text .btn-input-addon {
  background-color: var(--inputAddon) !important;
  color: var(--textColor) !important;
  border-radius: 0.25rem;
  font-weight: 500;
  font-size: 15px;
  opacity: 100% !important;
  width: 35px !important;
  height: 30px !important;
  padding: 0 !important;
  border: 0;
}
body .custom-input-group .custom-input-group-text .btn-input-addon:is(:active, :hover):enabled {
  background-color: var(--inputAddon) !important;
}
body .custom-input-group .custom-input-group-text .btn-input-addon:disabled {
  opacity: 0.5 !important;
  cursor: not-allowed;
}
body .custom-input-group .custom-input-group-text .input-form-control {
  min-height: 30px !important;
  height: 30px !important;
}
body .border-transparent {
  border-color: transparent !important;
}
body .text-gray-400 {
  color: var(--gray-400);
}
body button:disabled {
  cursor: not-allowed;
  pointer-events: all;
  opacity: 0.6;
}
body .pointer-events-none {
  pointer-events: none;
}
@media (min-width: 992px) {
  body .g-lg-40,
  body .gx-lg-40 {
    --bs-gutter-x: 2.5rem;
  }
  body .mb-lg-20 {
    margin-bottom: 1.25rem !important;
  }
  body .border-lg-end {
    border-right: 1px solid !important;
  }
}

@keyframes smooth-slide {
  0% {
    transform: scale(0) translateY(-100%);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes smooth-slide1 {
  0% {
    transform: translateY(-100%);
  }
}
@keyframes smooth-slide2 {
  0% {
    transform: scale(1) translateY(-100%);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes smooth-slide-x {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes smooth-slide-x1 {
  0% {
    transform: translateX(-100%);
  }
}
@keyframes smooth-slide-x2 {
  0% {
    transform: translateX(-100%);
  }
}
input:focus, input:focus-visible {
  box-shadow: none;
  outline: none;
}

#mines-fairness-popup .form-control {
  background-color: var(--primary-95);
  border-color: var(--buttonBg);
  border-radius: 4px !important;
  color: white;
}
#mines-fairness-popup .custom-text-field {
  min-height: 38px;
}
#mines-fairness-popup:focus {
  color: var(--textColor);
}

.form-control {
  padding-left: var(--input-ps, 0.5rem);
  padding-right: var(--input-pe, 0.5rem);
}

select option {
  color: var(--white);
  background: var(--bgPrimary);
}

.form-control.is-invalid:focus,
.was-validated .form-control:invalid:focus {
  box-shadow: none;
  border-color: red !important;
}

.form-control.is-invalid,
.was-validated .form-control:invalid {
  background-image: none;
}

.custom-bet-input {
  color: #DDDDDD;
  min-height: 3.25rem;
  max-width: fit-content;
}
.custom-bet-input:focus-visible {
  outline: none;
}

.gradient-btn, .gradient-btn-full {
  border-radius: 8px !important;
  background: linear-gradient(180deg, #FF9F45 0%, #EF7403 100%);
  box-shadow: 0px 0px 10px 0px rgba(255, 159, 69, 0.4), 0px 1px 0px 0px rgba(239, 116, 3, 0.6) inset, 0px -3px 0px 0px rgba(255, 159, 69, 0.3) inset, 0px 0px 15px 0px #EF7403 inset;
  color: #FFF;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  border: 0;
  padding: 10px 10px;
  min-height: 41px;
}
.gradient-btn:hover, .gradient-btn-full:hover {
  border-radius: 8px !important;
  background: linear-gradient(180deg, #FF9F45 0%, #EF7403 100%);
  box-shadow: 0px 0px 10px 0px rgba(255, 159, 69, 0.4), 0px 1px 0px 0px rgba(239, 116, 3, 0.6) inset, 0px -3px 0px 0px rgba(255, 159, 69, 0.3) inset, 0px 0px 15px 0px #EF7403 inset;
  color: #FFF;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  border: 0;
  padding: 10px 10px;
  min-height: 41px;
}

.gradient-btn-full {
  width: 100% !important;
}

@media (max-width: 991px) {
  .sidebar_mobile {
    display: flex;
    flex-direction: column;
  }
  .sidebar_mobile #place_bet_button {
    order: 1 !important;
  }
  .sidebar_mobile #place_bet_button {
    order: 1 !important;
    margin-top: 0 !important;
    position: relative;
    top: -10px;
  }
  .sidebar_mobile .WagerCaption {
    order: 2;
  }
  .sidebar_mobile .WagerInput {
    order: 3;
  }
  .sidebar_mobile .DifficultyCaption {
    order: 4;
  }
}
.items-center {
  align-items: center;
}

.font-semibold {
  font-weight: 600;
}

.conic-gradient-text, .conic-gradient-text-md, .conic-gradient-text-sm {
  background: conic-gradient(from 180deg at 50% 50%, #C29C00 0deg, #8D7100 360deg) !important;
  -webkit-background-clip: text !important;
  background-clip: text !important;
  color: transparent !important;
  line-height: 18px !important;
}

.conic-gradient-text-sm {
  font-size: 14px !important;
  font-weight: 400 !important;
}

.conic-gradient-text-md {
  font-size: 12px !important;
  font-weight: 600 !important;
}

.rotate-180 {
  transform: rotate(180deg);
}

.cursor-pointer {
  cursor: pointer !important;
}

.cursor-not-allowed {
  cursor: not-allowed !important;
}

/* Remove arrows in Chrome, Safari, Edge, Opera */
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Remove arrows in Firefox */
input[type=number] {
  -moz-appearance: textfield;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/_variables.scss","webpack://./src/index.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,sBAAA;EACA,sBAAA;EACA,mBAAA;EACA,4CAAA;EACA,mBAAA;EACA,qCAAA;EACA,oBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,yBAAA;EACA,uBAAA;EACA,qBAAA;EACA,kBAAA;EACA,sBAAA;EACA,qBAAA;EACA,oBAAA;EACA,mBAAA;EAGA,sBAAA;EACA,yBAAA;EACA,0BAAA;EAIA,sEAAA;EACA,2BAAA;EACA,8CAAA;EAEA,0BAAA;EAEA,0BAAA;EAEA,0CAAA;EAEA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,uBAAA;EAEA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kCAAA;EACA,kCAAA;EAEA,gBAAA;EACA,8BAAA;EACA,4BAAA;EAEA,qCAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,qCAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,qCAAA;EACA,mBAAA;EAGA,uCAAA;EACA,uCAAA;EACA,wCAAA;EACA,wCAAA;EACA,wCAAA;EACA,wCAAA;EACA,wCAAA;EACA,0CAAA;EACA,yCAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EAEA,mBAAA;EACA,mBAAA;EACA,mBAAA;EAEA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,sCAAA;EACA,wCAAA;EAEA,kBAAA;EACA,kBAAA;EACA,kBAAA;EAEA,mBAAA;EACA,mBAAA;EAEA,yCAAA;EACA,yCAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,sCAAA;EACA,uCAAA;EACA,uCAAA;EACA,uCAAA;EACA,yCAAA;EACA,oBAAA;EAEA,wGAAA;EAEA,iGAAA;EACA,0GAAA;EACA;2EAAA;EAGA,iGAAA;EACA,8EAAA;EACA,sGAAA;EACA,4GAAA;EACA,uLAAA;EACA,8GAAA;EACA;2EAAA;EAGA,uKAAA;EACA,wIAAA;EAEA,oGAAA;EAEA,mBAAA;EACA,mBAAA;EAGA,uBAAA;EAGA,4BAAA;EACA,2BAAA;EAGA,0BAAA;EACA,2BAAA;EACA,0BAAA;EACA,gCAAA;EACA,yBAAA;EACA,wBAAA;EACA,2BAAA;EACA,2BAAA;EACA,6BAAA;EACA,wBAAA;EACA,4BAAA;EACA,2BAAA;EACA,iCAAA;EACA,uBAAA;EAEA,0BAAA;EACA,wBAAA;EACA,wBAAA;EACA,0BAAA;EACA,uBAAA;EAEA,4BAAA;EACA,4EAAA;EAEA,6FAAA;EACA,6FAAA;EACA,sFAAA;EACA,4FAAA;EAIA,mBAAA;EACA,qFAAA;EAGA,oBAAA;EACA,oBAAA;EACA,sBAAA;EACA,sBAAA;ACtCF;;AAlJA;EACE,gBAAA;EACA,0CAAA;EACA,kCAAA;AAqJF;;AAlJA;;EAEE,YAAA;EACA,kBAAA;EACA,+BAAA;AAqJF;AAnJE;;EACE,WAAA;EACA,YAAA;AAsJJ;;AAjJE;EACE,oDAAA;EACA,iCAAA;EACA,mBAAA;AAoJJ;AAjJE;EACE,UAAA;EACA,iCAAA;EACA,mBAAA;EACA,WAAA;AAmJJ;AAhJE;EACE,mBAAA;EACA,iCAAA;AAkJJ;;AA9IA;EACE,mBAAA;EACA,mBAAA;EACA,4BAAA;EACA,yBAAA;EACA,kBAAA;EAEA,gBAAA;AAgJF;AA9IE;EACE,YAAA;AAgJJ;AA7IE;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,UAAA;EACA,aAAA;AA+IJ;AA7II;EAPF;IAQI,YAAA;EAgJJ;AACF;AA9II;EACE,SAAA;AAgJN;AA9IM;EAHF;IAII,8BAAA;EAiJN;AACF;AA1IM;EAJF;IAKI,YAAA;EA6IN;AACF;AA3IM;EACE,yBAAA;AA6IR;AAxIE;EACE,mCAAA;EACA,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AA0IJ;AAvIM;EACE,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,0BAAA;EACA,cAAA;EACA,YAAA;AAyIR;AAvIQ;EACE,oCAAA;EACA,mBAAA;EACA,YAAA;AAyIV;AAlII;EACE,wBAAA;AAoIN;AAlIM;EAEE,mCAAA;EACA,+BAAA;EACA,mBAAA;AAmIR;AA/HI;EACE,wBAAA;AAiIN;AA/HM;EAEE,mCAAA;EACA,+BAAA;EACA,sBAAA;AAgIR;AA5HI;EACE,qBAAA;AA8HN;AA5HM;EAEE,gCAAA;EACA,4BAAA;EACA,sBAAA;AA6HR;AAzHI;EACE,sBAAA;AA2HN;AAzHM;EAEE,iCAAA;EACA,6BAAA;EACA,sBAAA;AA0HR;AAtHI;EACE,iCAAA;EACA,6BAAA;EACA,mBAAA;EACA,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;AAwHN;AA9GM;;;EAGE,iCAAA;EACA,6BAAA;EACA,mBAAA;AAgHR;AA1GI;EACE,qFAAA;EACA,wBAAA;EACA,sCAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,WAAA;AA4GN;AAvGI;EACE,aAAA;AAyGN;AAvGM;EACE,8CAAA;EACA,kCAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,wBAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,SAAA;AAyGR;AAvGQ;EACE,8CAAA;AAyGV;AAtGQ;EACE,uBAAA;EACA,mBAAA;AAwGV;AAnGM;EACE,2BAAA;EACA,uBAAA;AAqGR;AAhGE;EACE,oCAAA;AAkGJ;AA/FE;EACE,sBAAA;AAiGJ;AA7FI;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;AA+FN;AA3FE;EACE,oBAAA;AA6FJ;AA1FE;EAEE;;IAEE,qBAAA;EA2FJ;EAxFE;IACE,iCAAA;EA0FJ;EAvFE;IACE,kCAAA;EAyFJ;AACF;;AArFA;EACE;IACE,qCAAA;EAwFF;EArFA;IACE,mBAAA;EAuFF;AACF;AApFA;EACE;IACE,4BAAA;EAsFF;AACF;AAnFA;EACE;IACE,qCAAA;EAqFF;EAlFA;IACE,mBAAA;EAoFF;AACF;AAjFA;EACE;IACE,mBAAA;EAmFF;EAhFA;IACE,mBAAA;EAkFF;AACF;AA/EA;EACE;IACE,4BAAA;EAiFF;AACF;AA9EA;EACE;IACE,4BAAA;EAgFF;AACF;AA3EE;EAEE,gBAAA;EACA,aAAA;AA4EJ;;AAvEE;EACE,mCAAA;EACA,6BAAA;EACA,6BAAA;EACA,YAAA;AA0EJ;AAvEE;EACE,gBAAA;AAyEJ;AAtEE;EACE,uBAAA;AAwEJ;;AApEA;EACE,qCAAA;EACA,sCAAA;AAuEF;;AAxDA;EACE,mBAAA;EACA,4BAAA;AA2DF;;AAxDA;;EAEE,gBAAA;EACA,4BAAA;AA2DF;;AAxDA;;EAEE,sBAAA;AA2DF;;AAxDA;EACE,cAAA;EACA,mBAAA;EACA,sBAAA;AA2DF;AAzDE;EACE,aAAA;AA2DJ;;AAvDA;EAjZE,6BAAA;EACA,6DAAA;EACA,kLAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;AA4cF;AAnEE;EApZA,6BAAA;EACA,6DAAA;EACA,kLAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;AA0dF;;AA5EA;EAEE,sBAAA;AA8EF;;AA1EA;EAKE;IACE,aAAA;IACA,sBAAA;EAyEF;EAvEA;IACE,mBAAA;EAyEF;EAtEA;IACE,mBAAA;IACA,wBAAA;IACA,kBAAA;IACA,UAAA;EAwEF;EArEA;IACE,QAAA;EAuEF;EApEA;IACE,QAAA;EAsEF;EAnEA;IACE,QAAA;EAqEF;AACF;AAlEA;EACE,mBAAA;AAoEF;;AAjEA;EACE,gBAAA;AAoEF;;AAjEA;EACE,2FAAA;EACA,wCAAA;EACA,gCAAA;EACA,6BAAA;EACA,4BAAA;AAoEF;;AAjEA;EAEE,0BAAA;EACA,2BAAA;AAmEF;;AAhEA;EAEE,0BAAA;EACA,2BAAA;AAkEF;;AA/DA;EACE,yBAAA;AAkEF;;AA/DA;EACE,0BAAA;AAkEF;;AA/DA;EACE,8BAAA;AAkEF;;AA/DA,iDAAA;AACA;;EAEE,wBAAA;EACA,SAAA;AAkEF;;AA/DA,6BAAA;AACA;EACE,0BAAA;AAkEF","sourcesContent":[":root {\n  --white: #ffffff;\n  --black: #000000;\n  --primary: #12151D;\n  --primary-95: #242837;\n  --TabBgActive: #12151D;\n  --golden: #FFC700;\n  --borderBg: #242837;\n  --HistoryText: #ECA72C;\n  --incrementBg: #060714;\n  --buttonBg: #EF7403;\n  --footerTopBorder: rgba(239, 239, 239, 0.25);\n  --multiple: #222224;\n  --TabColor: rgba(239, 239, 239, 0.50);\n  --textColor: #EFEFEF;\n  --autopickBg: #0A0A0D;\n  --success: #4DA500;\n  --danger: #F23546;\n  --Active: #52BA53;\n  --Loss: #D32B46;\n  --bodyBg: #000000;\n  --white-100: #efefef;\n  --borderColor: #5A84FF;\n  --checkBoxBorder: #47506F;\n  --toggleButton: #0D0710;\n  --WagerInput: #181B25;\n  --StateBg: #031430;\n  --historyLoss: #0A3477;\n  --inputAddon: #0270F0;\n  --riskLevel: #434C57;\n  --NumberBg: #353A47;\n\n  // Tap Tap Mine game\n  --TapTapBetBg: #0D1833;\n  --TapTapBetBtnBg: #FDFE8A;\n  --TapTapStartGame: #FF8F3B;\n\n\n  // dest new var\n  --dice-primary-main: linear-gradient(180deg, #FFA800 0%, #A86F00 100%);\n  --dice-primary-800: #6238BB;\n  --dice-primary-main-2: rgba(137, 83, 252, 0.2);\n\n  --dice-green-main: #2CB575;\n\n  --Game-Base-Green: #0D6F51;\n\n  --dice-dark-700-75: rgba(10, 12, 18, 0.75);\n\n  --dice-grey-100: #D9D9D9;\n  --dice-grey-200: #B4B6C1;\n  --dice-grey-300: #9598A7;\n  --dice-grey-400: #686C81;\n  --dice-grey-600: #49617C;\n  --diceSliderBg: #13151A;\n\n  --zinc-600: #52525B;\n  --zinc-650: #4C4C52;\n  --zinc-700: #252933;\n  --zinc-800: #27272A;\n  --zinc-850: #333333;\n  --zinc-900: #18181B;\n  --zinc-950: #09090B;\n  --zinc-950-06: rgba(9, 9, 11, 0.6);\n  --zinc-950-07: rgba(9, 9, 11, 0.7);\n\n  --black: #000000;\n  --black-20: rgba(0, 0, 0, 0.2);\n  --black-30: rgb(0 0 0 / 30%);\n\n  --gray-100-21: rgba(79, 79, 79, 0.21);\n  --gray-200: #696969;\n  --gray-300: #B8B8B8;\n  --gray-400: #949494;\n  --gray-700: #3D3D43;\n  --gray-750: #272727;\n  --gray-800: #212328;\n  --gray-850-32: rgba(35, 35, 35, 0.32);\n  --gray-850: #2A2A31;\n  --gray-900: #191A1E;\n  --gray-950: #232323;\n  --gray-900-15: rgb(126 126 126 / 21%);\n  --gray-975: #040404;\n\n  // history colors variables\n  --yellow-200-02: rgba(255, 230, 0, 0.2);\n  --yellow-200-04: rgba(255, 230, 0, 0.4);\n  --yellow-200-20: rgba(255, 229, 0, 0.20);\n  --yellow-200-24: rgba(255, 230, 0, 0.24);\n  --yellow-200-30: rgba(255, 229, 0, 0.30);\n  --yellow-200-54: rgba(255, 230, 0, 0.54);\n  --yellow-200-94: rgba(255, 230, 0, 0.94);\n  --yellow-300-60: rgba(255, 230, 117, 0.60);\n  --yellow-200-61: rgba(255, 222, 82, 0.61);\n  --yellow-400: #F6D76B;\n  --yellow-500: #F6C36B;\n  --yellow-600: #FFE353;\n  --yellow-700: #213621;\n  --yellow-800: #EBC500;\n  --yellow-900: #443D00;\n\n  --pink-300: #FE6969;\n  --pink-400: #E7635E;\n  --pink-600: #E34A5C;\n\n  --orange-300: #F0A265;\n  --orange-350: #F39946;\n  --orange-400: #F4754D;\n  --orange-500: #FF5C00;\n  --orange-900: rgba(244, 117, 77, 0.30);\n  --orange-950-40: rgba(255, 229, 0, 0.40);\n\n  --red-500: #EF4444;\n  --red-600: #F80027;\n  --red-900: #200000;\n\n  --cyan-400: #7EFFF0;\n  --cyan-900: #02312C;\n\n  --purple-100-08: rgba(179, 19, 255, 0.08);\n  --purple-100-30: rgba(179, 19, 255, 0.30);\n  --purple-200: #0689FF;\n  --purple-400: #8000FF;\n  --purple-500: #B313FF;\n  --purple-600-04: rgba(98, 1, 255, 0.4);\n  --purple-600-24: rgba(98, 1, 255, 0.24);\n  --purple-600-54: rgba(98, 1, 255, 0.54);\n  --purple-600-94: rgba(98, 1, 255, 0.94);\n  --purple-600-66: rgba(129, 59, 242, 0.66);\n  --green-400: #6CF96C;\n\n  --gameContainerBg: linear-gradient(180deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.02) 100%);\n\n  --purpleYellowRadialGradient: radial-gradient(76.67% 76.67% at 50% 50%, #FFE600 0%, #B947FF 100%);\n  --purpleYellowRadialGradientHover: radial-gradient(68.33% 68.33% at 50% 50%, #FFE600 44.27%, #B947FF 100%);\n  --purpleYellowRadialGradientActive: linear-gradient(0deg, rgba(255, 229, 0, 0.3), rgba(255, 229, 0, 0.3)),\n    radial-gradient(68.33% 68.33% at 50% 50%, #FFE600 22.92%, #B947FF 100%);\n  // plainko bet btn\n  --orangeYellowRadialGradient: radial-gradient(61.67% 61.67% at 50% 50%, #FFE500 0%, #FF7A01 100%);\n  --orangeYellowRadialGradientShadow: 0px 1px 12.2px 3px rgba(255, 229, 0, 0.40);\n  --orangeYellowRadialGradientHover: radial-gradient(61.67% 61.67% at 50% 50%, #FFFF46 0%, #F58E15 100%);\n  --orangeYellowRadialGradientHoverShadow: 0px 4px 0px 0px #AA5100, 0px 1px 12.2px 3px rgba(255, 229, 0, 0.40);\n  --orangeYellowRadialGradientDisable: linear-gradient(0deg, rgba(170, 81, 0, 0.30) 0%, rgba(170, 81, 0, 0.30) 100%), radial-gradient(61.67% 61.67% at 50% 50%, #FFFF46 0%, #F58E15 100%);\n  --orangeYellowRadialGradientDisableShadow: 0px 4px 0px 0px #AA5100, 0px 1px 12.2px 3px rgba(255, 229, 0, 0.40);\n  --orangeYellowRadialGradientActive: linear-gradient(0deg, rgba(255, 229, 0, 0.30) 0%, rgba(255, 229, 0, 0.30) 100%),\n    radial-gradient(68.33% 68.33% at 50% 50%, #FFE500 22.92%, #FF7A01 100%);\n\n  --plinkoBgGradient: linear-gradient(0deg, rgba(255, 77, 38, 0.40) 0%, rgba(255, 135, 24, 0.25) 7.29%, rgba(255, 229, 0, 0.00) 70.31%, rgba(255, 255, 255, 0.00) 94.27%);\n  --plinkoSidebarGradient: linear-gradient(0deg, rgba(7, 77, 198, 0.40) 0%, rgba(125, 33, 131, 0.40) 8.85%, rgba(35, 35, 35, 0.32) 94.27%);\n\n  --primaryBtnShadow: 0px 9px 7.099999904632568px 0px #FFFFFF7A inset, 0px -2px 10px 0px #D08732 inset;\n\n  --input-ps: 0.75rem;\n  --input-pe: 0.75rem;\n\n  //mine game\n  --mineplacebet: #252933;\n\n  //keno-game\n  --diamondBackground: #4F0473;\n  --diamondBlockText: #FFE500;\n\n  // pyramid-plinko color var\n  --PlinkoSidebarBg: #13151A;\n  --plinkoBtnPrimary: #252933;\n  --borderPinkColor: #BE3EFA;\n  --plinkoSwitchThumbnail: #5E29BB;\n  --plinkoSwitchBg: #17062C;\n  --plinkoInputBg: #220B3E;\n  --plinkoBtnGreen01: #45E90C;\n  --plinkoBtnGreen02: #02472E;\n  --plinkoSelectBorder: #4B2280;\n  --plinkoTableBg: #271142;\n  --plinkoHeaderBtnBg: #220B47;\n  --plinkoMusicMuted: #4D2198;\n  --plinkoSettingBtnBorder: #7340FF;\n  --plinkoHrLine: #3F1670;\n  // label colors\n  --plinkoOrange800: #FC6F1F;\n  --plinkoBlue700: #346DFF;\n  --plinkoBlue300: #3CBCB4;\n  --plinkoPurple500: #B122F4;\n  --plinkoRed800: #C82020;\n\n  --plinkoShadowGreen: #67FF4F;\n  --plinkoBtnPrimaryHover: linear-gradient(180deg, #BE3EFA 0%, #6217AC 82.61%);\n\n  --primaryGradient: linear-gradient(114.49deg, #8700C7 31.29%, #E06447 81.89%, #FFBF19 99.86%);\n  --primaryHoverGradient: linear-gradient(0deg, #8700C7 31.29%, #E06447 81.89%, #FFBF19 99.86%);\n  --sliderOverlayGradient: linear-gradient(270deg, #0A3477 0%, rgba(30, 10, 42, 0) 100%);\n  --sliderOverlayGradient180deg: linear-gradient(180deg, rgba(40, 17, 55, 0) 0%, #1A0825 100%);\n\n\n  // mine game ind\n  --onyx-700: #353B40;\n  --greenGradient: conic-gradient(from 180deg at 50% 50%, #1a9a8f 0deg, #0d6f51 360deg);\n  // end mine game ind\n\n  --white-o10: #8DE1A5;\n  --lightBlue: #4768E8;\n  --lightPurple: #9633FA;\n  --lightOrange: #E58808;\n}\n","@import \"./assets/scss/variables\";\n\n@mixin BetButton {\n  border-radius: 8px !important;\n  background: linear-gradient(180deg, #FF9F45 0%, #EF7403 100%);\n  box-shadow: 0px 0px 10px 0px rgba(255, 159, 69, 0.40), 0px 1px 0px 0px rgba(239, 116, 3, 0.60) inset, 0px -3px 0px 0px rgba(255, 159, 69, 0.30) inset, 0px 0px 15px 0px #EF7403 inset;\n  color: #FFF;\n  text-align: center;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 150%;\n  border: 0;\n  padding: 10px 10px;\n  min-height: 41px;\n}\n\n.form-control:focus {\n  box-shadow: none;\n  border-color: var(--primary-95) !important;\n  color: var(--textColor) !important;\n}\n\nhtml,\nbody {\n  height: 100%;\n  overflow-x: hidden;\n  background-color: var(--bodyBg);\n\n  .spinner-border {\n    width: 1rem;\n    height: 1rem;\n  }\n}\n\n* {\n  &::-webkit-scrollbar-track {\n    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n    background-color: var(--zinc-700);\n    border-radius: 50em;\n  }\n\n  &::-webkit-scrollbar {\n    width: 2px;\n    background-color: var(--zinc-700);\n    border-radius: 50em;\n    height: 5px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    border-radius: 50em;\n    background-color: var(--gray-400);\n  }\n}\n\nbody {\n  color: var(--white);\n  font-size: 0.938rem;\n  font-family: \"Lexend\", serif;\n  font-optical-sizing: auto;\n  font-style: normal;\n\n  font-weight: 500;\n\n  #root {\n    height: 100%;\n  }\n\n  .container-fluid {\n    max-width: 100%;\n    border-radius: 0;\n    background: var(--primary);\n    padding: 0;\n    height: 100vh;\n\n    @media screen and (max-width: 991.98px) {\n      height: auto;\n    }\n\n    .parent {\n      gap: 12px;\n\n      @media screen and (max-width: 991px) {\n        flex-direction: column-reverse;\n      }\n    }\n\n    &.multi-crash {\n\n      // padding: 1rem ;\n      // height: 100vh;\n      @media screen and (max-width: 767.99px) {\n        height: auto;\n      }\n\n      .row {\n        height: calc(100% - 57px);\n      }\n    }\n  }\n\n  .nav-tabs {\n    background-color: var(--primary-95);\n    border-radius: 8px;\n    padding: 0.5px 2.5px;\n    width: 100%;\n    max-width: 100%;\n    margin: 0 auto;\n    padding-bottom: 2px;\n\n    .nav-item {\n      .nav-link {\n        color: var(--TabColor);\n        border-radius: 8px;\n        padding: 0;\n        font-size: 14px;\n        font-weight: 600;\n        line-height: 1;\n        text-transform: capitalize;\n        padding: 4px 0;\n        height: 40px;\n\n        &.active {\n          background-color: var(--TabBgActive);\n          color: var(--white);\n          height: 100%;\n        }\n      }\n    }\n  }\n\n  .btn-nav-tabs {\n    .btn-nav-tab-items:nth-child(1) .btn-tab {\n      color: var(--yellow-700);\n\n      &:is(:hover):enabled:not(.active),\n      &.active {\n        background-color: var(--yellow-400);\n        border-color: var(--yellow-400);\n        color: var(--black);\n      }\n    }\n\n    .btn-nav-tab-items:nth-child(2) .btn-tab {\n      color: var(--orange-400);\n\n      &:is(:hover):enabled:not(.active),\n      &.active {\n        background-color: var(--orange-400);\n        border-color: var(--orange-400);\n        color: var(--zinc-950);\n      }\n    }\n\n    .btn-nav-tab-items:nth-child(3) .btn-tab {\n      color: var(--red-500);\n\n      &:is(:hover):enabled:not(.active),\n      &.active {\n        background-color: var(--red-500);\n        border-color: var(--red-500);\n        color: var(--zinc-950);\n      }\n    }\n\n    .btn-nav-tab-items:nth-child(4) .btn-tab {\n      color: var(--cyan-400);\n\n      &:is(:hover):enabled:not(.active),\n      &.active {\n        background-color: var(--cyan-400);\n        border-color: var(--cyan-400);\n        color: var(--zinc-950);\n      }\n    }\n\n    .btn-tab {\n      background-color: var(--zinc-800);\n      border-color: var(--zinc-800);\n      color: var(--white);\n      padding: 0.25rem 0.25rem;\n      font-weight: 500;\n      min-width: 48px;\n      height: 36px;\n      border-radius: 0.25rem;\n      // &.active {\n      //   background-color: var(--orange-400);\n      //   border-color: var(--orange-400);\n      //   color: var(--zinc-950) !important;\n      // }\n    }\n\n    .strategy-btn-box {\n\n      .btn-outline-warning:hover,\n      .btn-outline-orange:hover,\n      .btn-outline-danger:hover {\n        background-color: var(--zinc-800);\n        border-color: var(--zinc-700);\n        color: var(--white);\n      }\n    }\n  }\n\n  select {\n    &.form-control {\n      background: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23ffffff' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e\") no-repeat right var(--primary-95);\n      -webkit-appearance: none;\n      background-position: calc(100% - 12px);\n      background-size: 16px;\n      padding-right: 35px !important;\n      border-color: var(--buttonBg);\n      color: #fff;\n    }\n  }\n\n  .custom-input-group {\n    .custom-input-group-text {\n      gap: 0.375rem;\n\n      .btn-input-addon {\n        background-color: var(--inputAddon) !important;\n        color: var(--textColor) !important;\n        border-radius: 0.25rem;\n        font-weight: 500;\n        font-size: 15px;\n        opacity: 100% !important;\n        width: 35px !important;\n        height: 30px !important;\n        padding: 0 !important;\n        border: 0;\n\n        &:is(:active, :hover):enabled {\n          background-color: var(--inputAddon) !important;\n        }\n\n        &:disabled {\n          opacity: 0.5 !important;\n          cursor: not-allowed;\n        }\n      }\n\n\n      .input-form-control {\n        min-height: 30px !important;\n        height: 30px !important;\n      }\n    }\n  }\n\n  .border-transparent {\n    border-color: transparent !important;\n  }\n\n  .text-gray-400 {\n    color: var(--gray-400);\n  }\n\n  button {\n    &:disabled {\n      cursor: not-allowed;\n      pointer-events: all;\n      opacity: 0.6;\n    }\n  }\n\n  .pointer-events-none {\n    pointer-events: none;\n  }\n\n  @media (min-width: 992px) {\n\n    .g-lg-40,\n    .gx-lg-40 {\n      --bs-gutter-x: 2.5rem;\n    }\n\n    .mb-lg-20 {\n      margin-bottom: 1.25rem !important;\n    }\n\n    .border-lg-end {\n      border-right: 1px solid !important;\n    }\n  }\n}\n\n@keyframes smooth-slide {\n  0% {\n    transform: scale(0) translateY(-100%);\n  }\n\n  100% {\n    transform: scale(1);\n  }\n}\n\n@keyframes smooth-slide1 {\n  0% {\n    transform: translateY(-100%);\n  }\n}\n\n@keyframes smooth-slide2 {\n  0% {\n    transform: scale(1) translateY(-100%);\n  }\n\n  100% {\n    transform: scale(0);\n  }\n}\n\n@keyframes smooth-slide-x {\n  0% {\n    transform: scale(0);\n  }\n\n  100% {\n    transform: scale(1);\n  }\n}\n\n@keyframes smooth-slide-x1 {\n  0% {\n    transform: translateX(-100%);\n  }\n}\n\n@keyframes smooth-slide-x2 {\n  0% {\n    transform: translateX(-100%);\n  }\n}\n\ninput {\n\n  &:focus,\n  &:focus-visible {\n    box-shadow: none;\n    outline: none;\n  }\n}\n\n#mines-fairness-popup {\n  .form-control {\n    background-color: var(--primary-95);\n    border-color: var(--buttonBg);\n    border-radius: 4px !important;\n    color: white;\n  }\n\n  .custom-text-field {\n    min-height: 38px;\n  }\n\n  &:focus {\n    color: var(--textColor);\n  }\n}\n\n.form-control {\n  padding-left: var(--input-ps, 0.5rem);\n  padding-right: var(--input-pe, 0.5rem);\n}\n\n// /* Chrome, Safari, Edge, Opera */\n// input::-webkit-outer-spin-button,\n// input::-webkit-inner-spin-button {\n//   transform: scale(0);\n// }\n\n// /* Firefox */\n// input[type=number] {\n//   appearance: textfield;\n//   -moz-appearance: textfield;\n// }\n\nselect option {\n  color: var(--white);\n  background: var(--bgPrimary);\n}\n\n.form-control.is-invalid:focus,\n.was-validated .form-control:invalid:focus {\n  box-shadow: none;\n  border-color: red !important;\n}\n\n.form-control.is-invalid,\n.was-validated .form-control:invalid {\n  background-image: none;\n}\n\n.custom-bet-input {\n  color: #DDDDDD;\n  min-height: 3.25rem;\n  max-width: fit-content;\n\n  &:focus-visible {\n    outline: none;\n  }\n}\n\n.gradient-btn {\n  @include BetButton();\n\n  &:hover {\n    @include BetButton();\n  }\n}\n\n.gradient-btn-full {\n  @extend .gradient-btn;\n  width: 100% !important;\n}\n\n\n@media (max-width: 991px) {\n  // .gradient-btn {\n  //   position: relative;\n  //   top: -160px;\n  // }\n  .sidebar_mobile{\n    display: flex;\n    flex-direction: column;\n  }\n  .sidebar_mobile #place_bet_button{\n    order : 1 !important;\n  }\n\n  .sidebar_mobile #place_bet_button{\n    order : 1 !important;\n    margin-top: 0 !important;\n    position: relative;\n    top: -10px;\n  }\n\n  .sidebar_mobile .WagerCaption{\n    order : 2;\n  }\n\n  .sidebar_mobile .WagerInput{\n    order : 3;\n  }\n\n  .sidebar_mobile .DifficultyCaption{\n    order : 4;\n  }\n\n}\n.items-center {\n  align-items: center;\n}\n\n.font-semibold {\n  font-weight: 600;\n}\n\n.conic-gradient-text {\n  background: conic-gradient(from 180deg at 50% 50%, #C29C00 0deg, #8D7100 360deg) !important;\n  -webkit-background-clip: text !important;\n  background-clip: text !important;\n  color: transparent !important;\n  line-height: 18px !important;\n}\n\n.conic-gradient-text-sm {\n  @extend .conic-gradient-text;\n  font-size: 14px !important;\n  font-weight: 400 !important;\n}\n\n.conic-gradient-text-md {\n  @extend .conic-gradient-text;\n  font-size: 12px !important;\n  font-weight: 600 !important;\n}\n\n.rotate-180 {\n  transform: rotate(180deg);\n}\n\n.cursor-pointer {\n  cursor: pointer !important;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n/* Remove arrows in Chrome, Safari, Edge, Opera */\ninput[type=number]::-webkit-inner-spin-button,\ninput[type=number]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Remove arrows in Firefox */\ninput[type=number] {\n  -moz-appearance: textfield;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
